module.exports = __webpack_public_path__ + "static/media/fileType.f03f9a54.svg";